import { action, observable } from 'mobx';
import ServiceModel from './ServiceModel';

class ServiceStore {
    @observable fetching = false;
    @observable fetched = false;
    @observable service = null;
    @observable services = [];

    auth = null;

    constructor(auth) {
        // Set auth
        this.auth = auth;
    }

    @action.bound
    fetch() {
        this.fetching = true;
        this.auth.apiGet('/api/services')
            .then(action('update state after fetching data', (data) => {
                const newServiceList = data.map(item => ServiceModel.fromJS(this.auth, item));
                this.services.replace(newServiceList);
                this.fetched = true;
                this.fetching = false;
            }));
    }

    @action.bound
    fetchService(id) {
        if (this.service && this.service.id === id) {
            // Don't reload if it's the same one
            return this.service;
        }

        this.fetching = true;
        return this.auth.apiGet(`/api/services/${id}`)
            .then(action('update state after fetching data', (data) => {
                const newService = ServiceModel.fromJS(this.auth, data);
                this.service = newService;
                this.fetched = true;
                this.fetching = false;
                return this.service;
            }));
    }

    // syncUpdate() {
    //     // this.auth.socket.syncUpdates('service', this.services);
    // }

    // unsyncUpdates() {
    //     // this.auth.socket.unsyncUpdates('service');
    // }

    toJS() {
        return this.services.map(s => s.toJS());
    }

    static fromJS(auth, array) {
        const serviceStore = new ServiceStore(auth);
        serviceStore.services = array.map(item => ServiceModel.fromJS(auth, item));
        return serviceStore;
    }
}

export default ServiceStore;
